<template>
  <el-aside class="aside-en" width="40%" v-if="lang==='en'">
    <el-scrollbar style="height: 100%; width: 100%">
      <div class="aside-content">
        <!--      <h1 class="tit">Rank No.1 on Google Play with ASOGrow</h1>-->
        <div class="bonus-container">
          <div class="bonus-tit bonus-tit1">Recharge online and get</div>
          <div class="bonus-icon">
            <img src="../assets/img/bonus@2x.png" alt="bonus" />
          </div>
          <div class="bonus-tit bonus-tit2">For Your First Online Recharge</div>
          <div class="bonus-content">
            <img src="../assets/img/bonus1.png" alt="bonus content" />
            <img src="../assets/img/bonus2.png" alt="bonus content" />
          </div>
        </div>
        <div class="steps">
          <h2 class="steps-tit">Place Your Ads on ASOGrow Platform Now</h2>
          <div class="step">
            <section class="step-container">
              <img class="st-icon-end" src="../assets/img/step-1.png" />
              <div class="step-left">
                <img class="st-icon" src="../assets/img/st-icon1.png" alt="step1" />
                <span class="st-msg">Sign Up for free.</span>
              </div>
            </section>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../assets/img/st-icon2.png" alt="step2" />
                <span class="st-msg">Activate your account via email.</span>
              </div>
              <img class="st-icon-end" src="../assets/img/step-2.png" />
            </section>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../assets/img/st-icon3.png" alt="step3" />
                <span class="st-msg">Top up your ASO advertising account.</span>
              </div>
              <img class="st-icon-end" src="../assets/img/step-3.png" />
            </section>
            <section class="step-container">
              <div class="step-left">
                <img class="st-icon" src="../assets/img/st-icon4.png" alt="step4" />
                <span class="st-msg">Create and run your campaign automatically.</span>
              </div>
              <img class="st-icon-end" src="../assets/img/step-4.png" />
            </section>
          </div>
        </div>

        <div class="contact">
          <div class="contact-tit">Contact AM</div>
          <div class="contact-item" v-for="(am, index) in am_list" :key="index">
            <div class="contact-container">
              <img class="avatar" src="../assets/img/contact.png" />
              <div class="contact-message">
                <div class="msg-item">
                  <i class="iconfont icon-FullName icon-grey mr-1"></i>
                  <label>{{ am.name }}</label>
                </div>
                <div class="msg-item">
                  <i class="iconfont icon-Email icon-grey mr-1"></i>
                  <label>{{ am.skype }}</label>
                </div>
                <div class="msg-item">
                  <i class="iconfont icon-Skype icon-grey mr-1"></i>
                  <label>{{ am.email }}</label>
                </div>
                <div class="msg-item">
                  <i class="iconfont icon-WhatApp icon-grey mr-1"></i>
                  <label>{{ am.whatsapp }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </el-aside>
  <el-aside class="aside-zh" width="40%" v-else>
    <el-scrollbar style="height: 100%; width: 100%">
      <div class="aside-content">
        <div class="aside-head">
          <img class="logo" src="../assets/img/aside-tit1.png" alt="logo"/>
        </div>
        <div class="aside-logo">
          <img class="logo" src="../assets/img/aside-tit2.png" alt="logo"/>
        </div>
        <div class="aside-list">
          <div class="aside-item">
            <img src="../assets/img/aside-item1.png" alt="logo"/>
            <p>轻松出量</p>
          </div>
          <div class="aside-item">
            <img src="../assets/img/aside-item2.png" alt="logo"/>
            <p>极速开户</p>
          </div>
          <div class="aside-item">
            <img src="../assets/img/aside-item3.png" alt="logo"/>
            <p>真实用户</p>
          </div>
          <div class="aside-item">
            <img src="../assets/img/aside-item4.png" alt="logo"/>
            <p>实时报表</p>
          </div>
        </div>
        <img class="aside-mid-img" src="../assets/img/aside-mid-zh.png" alt="logo"/>
      </div>
    </el-scrollbar>
  </el-aside>
</template>

<script>
export default {
  name: 'commonAside',
  data() {
    return {
      lang:this.$i18n.locale,// zh en
      am_list: [
        {
          name: 'Doria',
          email: 'mrk@youmi.net',
          skype: 'mrk@youmi.net',
          whatsapp: '+86 18028539642',
        },
      ],
    }
  },
  watch:{
    '$i18n.locale': function (val) {
      this.lang=val
    },
  },
}
</script>

<style lang="scss">
.aside-en {
  height: 100vh;
  background: url(../assets/img/aside-bg.png) no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  .aside-content {
    width: 80%;
    margin: 60px auto 30px;
    color: #ffffff;
    .tit {
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 32px 0;
      line-height: 32px;
    }
    .step {
      display: flex;
      justify-content: space-between;
    }
    .steps-tit {
      font-size: 16px;
      font-weight: 300;
      line-height: 24px;
      margin: 0 0 8px 0;
    }
    .steps-tit::before {
      content: '';
      display: inline-block;
      height: 16px;
      border-left: 4px solid #e30077;
      vertical-align: -3px;
      margin-right: 8px;
    }
    .step-container {
      width: 23%;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      box-sizing: border-box;
      padding: 40px 16px 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      .step-left {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .st-icon {
        width: 56px;
        height: 56px;
        margin-bottom: 8px;
      }
      .st-msg {
        font-weight: 400;
        display: inline-flex;
        align-items: center;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #c0c4cc;
      }
      .st-icon-end {
        width: 40px;
        height: 40px;
        position: absolute;
        left: -6px;
        top: -6px;
      }
    }
    .next-step-icon {
      font-size: 37px;
      color: rgba(255, 255, 255, 0.3);
      margin: 4px 222px;
    }
    .contact {
      margin-top: 24px;
      .contact-tit {
        border-left: 4px solid #e30077;
        padding-left: 8px;
        margin-bottom: 8px;
        font-weight: 300;
        font-size: 16px;
      }
      .contact-item {
        box-sizing: border-box;
        width: 100%;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 8px;
        .caption {
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          margin-bottom: 12px;
        }
        .contact-container {
          display: flex;
          .avatar {
            display: block;
            width: 48px;
            height: 48px;
          }
          .contact-message {
            width: 100%;
            height: 48px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-left: 12px;
            .msg-item {
              width: 50%;
              height: 22px;
              line-height: 22px;
              color: #c0c4cc;
              font-size: 14px;
            }
          }
        }
      }
    }

    .bonus-container {
      margin-bottom: 24px;
      .bonus-tit {
        font-weight: 700;
        font-size: 28px;
        line-height: 32px;
        text-align: center;
      }
      .bonus-tit1 {
        text-transform: uppercase;
      }
      .bonus-tit2 {
        margin-bottom: 24px;
      }
      .bonus-icon {
        text-align: center;
        img {
          width: 136px;
          height: auto;
        }
      }
      .bonus-content {
        display: flex;
        justify-content: space-between;
        img {
          width: 211px;
          height: auto;
        }
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow: auto;
  }
}
.aside-zh {
  height: 100vh;
  background: url(../assets/img/aside-new-bg.png) no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  .aside-content {
    width: 80%;
    margin: 60px auto 30px;
    color: #ffffff;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow: auto;
  }
  .aside-head{
    margin-bottom: 26px;
    >img{
      width: 100%;
    }
  }
  .aside-logo{
    padding: 0 38px;
    margin-bottom: 38px;
    >img{
      width: 100%;
    }
  }
  .aside-list{
    display: flex;
    justify-content: space-between;
    margin-bottom: 35px;
    .aside-item{
      width: 23%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 96px;
      >img{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        height: 94px;
      }
      >p{
        font-weight: 500;
        color: #FFFFFF;
        font-size: 16px;
        margin-top: 16px;
      }
    }
  }
  .aside-mid-img{
    width: 100%;
    // width: 110%;
    // margin-left: -5%;
  }
}

@media screen and (max-width: 900px) {
  .aside-zh,.aside-en{
    display: none;
  }
}

@media screen and (max-width: 1367px) {
  .aside-en {
    .bonus-tit1,
    .bonus-tit2 {
      font-size: 20px !important;
      font-weight: bold !important;
    }
    .aside-content {
      margin-top: 28px !important;
      margin-bottom: 42px !important;
    }
    .bonus-container {
      margin-bottom: 4px !important;
    }
    .contact {
      margin-bottom: 15px !important;
    }
    .bonus-tit2 {
      margin-bottom: 0px !important;
    }
  }

  .aside-zh {
    .aside-head{
      margin-bottom: 8px;
    }
    .aside-content {
      margin-top: 42px !important;
      margin-bottom: 28px !important;
    }
    .aside-mid-img{
      width: 100%;
      margin-left: 0;
    }
    .aside-list .aside-item{
      height: 86px;
    }
    .aside-list .aside-item > p{
      font-size: 14px;
      margin-top: 4px;
    }
    .aside-list .aside-item > img{
      height:75px;
    }
    .aside-logo{
      margin-bottom: 6px;
    }
    .aside-list{
      margin-bottom:5px;
    }
  }
}
@media screen and (min-width: 1367px) and (max-width: 1920px) {
  .aside-en {
    .bonus-content {
      justify-content: space-around !important;
    }
    .aside-content {
      margin-top: 128px;
    }
  }
   .aside-zh {
    .bonus-content {
      justify-content: space-around !important;
    }
    .aside-content {
      margin-top: 40px;
      margin-bottom: 0px;
    }
    .aside-mid-img{
      width: 106%;
      margin-left: -3%;
    }
    .aside-logo{
      margin-bottom: 20px;
    }
    .aside-list{
      margin-bottom: 25px;
    }
    .aside-head{
      margin-bottom: 14px;
      >img{
        width: 96%;
        margin-left: 2%;
      }
    }
  }

}
</style>
